import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';
import { Paragraph, ParagraphProps } from '../Paragraph';

export const StyledTierParagraph = styled(Paragraph)`
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.dStyles.elements.tierParagraph,
    )}
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements.tierParagraph,
    )}
`;

export type TierParagraphProps = ParagraphProps;

export const TierParagraph = ({ text }: TierParagraphProps) => {
  return <StyledTierParagraph text={text} />;
};
